export default __webpack_public_path__ + "media/cfe87016370b7e670a6911d18ebca69fb5e346a48cbe28ffdaba4f72a6492912.svg";